import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';

export function usePaymentApps(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.paymentApps.all(orgId ?? ''),
    queryFn: () => financialService.getPaymentApps(orgId ?? undefined),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : res.data?.data ?? [],
  });
}
